import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class S3uploadsService {

  constructor(private http: HttpClient) { }

  private baseUrl: string = environment.apiUrl;

  private static handleError(error: HttpErrorResponse) {
    console.log(error);

    // return an observable with a user friendly message
    return throwError('Error! something went wrong.');
  }

  getSigendUrl(Payload) {
    return this.http.post<any>(`${this.baseUrl}/helper/getSignedUrl`, Payload)
      .pipe(map(res => {
        return res;
      }));
  }

  async uploadToS3(Payload) {
    console.log('1. SelectedFile: ', Payload.selectedFile);
    const body = { fileName: Payload.selectedFile.name, type: Payload.type.toUpperCase() }
    const preSignedUrl = await this.getSigendUrl(body).toPromise();
    console.log('2. PreSignedURL: ', preSignedUrl)
    console.log('3. Upoloading File (binary) to S3')

    // const upload = this.http.put(preSignedUrl.presinedUrl, this.selectedFile).toPromise();
    // upload.then(data => {
    //   console.log('=> ', data)
    // }).catch(err => console.log('error: ', err))

  }

  uploadFileViaUri(path,Payload) {
    return this.http.put<any>(`${path}`, Payload)
      .pipe(map(res => {
        return res;
      }));

  }
}
